import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取列表
export const getList = params => {
  return axios.request({
    url: "/finance/zaf/hq/sale/index",
    params,
    method: "get"
  });
};

export const detail = params => {
  return axios.request({
    url: "/finance/zaf/hq/sale/detail/"+params.id,
    params,
    method: "get"
  });
};

export const conf = params => {
  return axios.request({
    url: "/finance/zaf/hq/sale/conf/"+params.id,
    params,
    method: "get"
  });
};

export const finance = data => {
  return axios.request({
    url: "/finance/zaf/hq/sale/finance",
    data,
    method: "post"
  });
};

export const getRemark = params => {
  return axios.request({
    url: "/finance/zaf/hq/sale/remark",
    params,
    method: "get"
  });
};

export const showQuote = data => {
	
  return axios.request({
    url: `/finance/zaf/${data.branch?'branch':'hq'}/bill/showQuote`,
    data,
    method: "post"
  });
};